import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/Shared/common.service';

export interface ClauseAuditTrailDialogData {
    clauseGTCId: number;
    clauseNumber: number;
}

@Component({
    selector: 'app-clause-audit-trail',
    templateUrl: './clause-audit-trail.component.html',
    styleUrls: ['./clause-audit-trail.component.css']
})
export class ClauseAuditTrailComponent implements OnInit {

    IsLoadingResults: boolean = false;
    displayedColumns = ['RecordId', 'Action', 'FieldName', 'OldValue', 'NewValue', 'ModifiedOn', 'UpdatedBy'];
    dataSource!: MatTableDataSource<any>;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    constructor(
        public dialogRef: MatDialogRef<ClauseAuditTrailComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: ClauseAuditTrailDialogData,
        private commonService: CommonService
    ) { }

    ngOnInit() {
        this.loadAuditTrail();
    }

    loadAuditTrail() {
        if (this._data.clauseGTCId) {
            this.IsLoadingResults = true;
            this.commonService.getClauseDetailAuditTrail(this._data.clauseGTCId)
                .subscribe(
                    (data: any) => {
                        this.IsLoadingResults = false;
                        this.dataSource = new MatTableDataSource<any>(Array.isArray(data) ? data : []);
                        this.dataSource.paginator = this.paginator;
                        this.dataSource.sort = this.sort;
                    },
                    (error: any) => {
                        this.IsLoadingResults = false;
                        console.error('Error loading clause audit trail:', error);
                    }
                );
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
